import { ShowForCountry } from '../../../api/concierge';

import { PromotionList } from './types';

export enum PromotionsEndpoints {
    getPromotions = '/v1/promotions',
}

export const MidYearRebookersPromotionList: PromotionList = [
    {
        offer_id: 'mid-year-rebookers-vs',
        title: {
            en: 'Rebook for next year on Thursday 23rd April, and you’ll get two weeks free.',
            es: 'Re-reserva para el próximo año el jueves 23 de abril y recibirás dos semanas gratis.',
        },
        sub_title: {
            en: "Love it? Keep living it. It's not too late.",
            es: '¿Te encanta? Sigue viviéndolo. No es demasiado tarde.',
        },
        description: {
            en: '',
            es: '',
        },
        external_url:
            'https://vitastudent.typeform.com/to/T9qKaogd#email={email}&room_name={roomCode}',
        image_url:
            'https://cdn.brandfolder.io/2EZAWJN8/at/qxwpnspgxstzcshmbpzw4vw/VS26_032_My_Account_2000x800px_15x_1.png?width=2000&height=800',
        display_on_web: true,
        order: 1,
        object_id: 'mid-year-rebookers-vs',
        show_for_country: ShowForCountry.ALL,
        show_on_vs: false,
        show_on_hos: false,
    },
    {
        offer_id: 'mid-year-rebookers-hos',
        title: {
            en: 'Rebook for next year on Thursday 23rd April, and you’ll get two weeks free.',
            es: 'Re-reserva para el próximo año el jueves 23 de abril y recibirás dos semanas gratis.',
        },
        sub_title: {
            en: "Love it? Keep living it. It's not too late.",
            es: '¿Te encanta? Sigue viviéndolo. No es demasiado tarde.',
        },
        description: {
            en: '',
            es: '',
        },
        external_url:
            'https://vitastudent.typeform.com/to/OXItHv1G#email={email}&room_name={roomCode}',
        image_url:
            'https://cdn.brandfolder.io/2EZAWJN8/at/3pbcvhp4tthk6qtmm8b6tm7/HOS177_Rebookers-April-Push_MyAccount_Offer_02.png',
        display_on_web: true,
        order: 1,
        object_id: 'mid-year-rebookers-hos',
        show_for_country: ShowForCountry.ALL,
        show_on_vs: false,
        show_on_hos: false,
    },
];

export const MidYearRebookersReferralsPromotionList: PromotionList = [
    {
        offer_id: 'mid-year-rebookers-referrals-vs',
        title: {
            en: 'If your friend books on Friday 24th April they get a week free, alongside the shared referral cash reward',
            es: 'Si tu amigo reserva el viernes 24 de abril, recibirá una semana gratis, además de la recompensa en efectivo compartida por tu recomendación.',
        },
        sub_title: { en: 'Live with friends next year.', es: 'Vive con amigos el próximo año.' },
        description: { en: '', es: '' },
        external_url: 'https://www.vitastudent.com/{language}/vita-collective/',
        image_url:
            'https://cdn.brandfolder.io/2EZAWJN8/at/j78n7r5tbw5p6m88vf9rsph/VS26_032_Referral_My_Account_2000x800px_1.png',
        display_on_web: true,
        order: 1,
        object_id: 'mid-year-rebookers-referrals-vs',
        show_for_country: ShowForCountry.ALL,
        show_on_vs: false,
        show_on_hos: false,
    },
    {
        offer_id: 'mid-year-rebookers-referrals-hos',
        title: {
            en: 'If your friend books on Friday 24th April they get a week free, alongside the shared referral cash reward',
            es: 'Si tu amigo reserva el viernes 24 de abril, recibirá una semana gratis, además de la recompensa en efectivo compartida por tu recomendación.',
        },
        sub_title: { en: 'Live with friends next year.', es: 'Vive con amigos el próximo año.' },
        description: { en: '', es: '' },
        external_url: 'https://www.houseofsocial.com/refer-your-mates/',
        image_url:
            'https://cdn.brandfolder.io/2EZAWJN8/at/vvbm9cbkp7385bngm898cnjm/HOS177_Rebookers-April-Push_MyAccount_Evergreen_01.png',
        display_on_web: true,
        order: 1,
        object_id: 'mid-year-rebookers-referrals-hos',
        show_for_country: ShowForCountry.ALL,
        show_on_vs: false,
        show_on_hos: false,
    },
];
